document.addEventListener('DOMContentLoaded', function () {
console.log("loadeddd1")

// ===== DRAWER ARIA-HIDDEN INTERCEPTOR - MUST RUN FIRST =====
// Function to wrap drawer's setAttribute to intercept aria-hidden changes
function wrapDrawerSetAttribute(drawer) {
  if (!drawer || drawer.__ariaHiddenWrapped) {
    return; // Already wrapped or doesn't exist
  }
  
  // Mark as wrapped
  drawer.__ariaHiddenWrapped = true;
  
  // Store the original setAttribute method
  const originalSetAttribute = Element.prototype.setAttribute.bind(drawer);
  
  // Override setAttribute to intercept aria-hidden changes
  Object.defineProperty(drawer, 'setAttribute', {
    value: function(name, value) {
      if (name === 'aria-hidden' && value === 'true') {
        // Before setting aria-hidden to true, ensure no element inside has focus
        const activeElement = document.activeElement;
        if (activeElement && this.contains && this.contains(activeElement)) {
          // Remove focus synchronously before setting aria-hidden
          activeElement.blur();
          // Move focus to body
          if (document.body && document.body !== activeElement) {
            // Body needs tabindex to receive focus
            const hadTabIndex = document.body.hasAttribute('tabindex');
            if (!hadTabIndex) {
              document.body.setAttribute('tabindex', '-1');
            }
            document.body.focus();
            // Remove tabindex after a brief moment if we added it
            if (!hadTabIndex) {
              setTimeout(() => {
                document.body.removeAttribute('tabindex');
              }, 0);
            }
          }
        }
      }
      // Call the original setAttribute
      return originalSetAttribute(name, value);
    },
    writable: true,
    configurable: true
  });
}

// Intercept drawer's setAttribute - try immediately and also watch for drawer creation
function initDrawerAriaHiddenInterceptor() {
  const drawer = document.querySelector('#t4s-mini_cart');
  if (drawer) {
    wrapDrawerSetAttribute(drawer);
    
    // Also add a MutationObserver as a backup to catch any aria-hidden changes
    const backupObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          const newValue = drawer.getAttribute('aria-hidden');
          if (newValue === 'true') {
            // Immediately remove focus if any element inside has focus
            const activeElement = document.activeElement;
            if (activeElement && drawer.contains && drawer.contains(activeElement)) {
              activeElement.blur();
              // Move focus outside
              if (document.body && document.body !== activeElement) {
                const hadTabIndex = document.body.hasAttribute('tabindex');
                if (!hadTabIndex) {
                  document.body.setAttribute('tabindex', '-1');
                }
                document.body.focus();
                if (!hadTabIndex) {
                  setTimeout(() => {
                    document.body.removeAttribute('tabindex');
                  }, 0);
                }
              }
            }
          }
        }
      });
    });
    
    backupObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }
  
  // Also watch for drawer being added to DOM or updated
  if (document.body) {
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Check for drawer being added
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.id === 't4s-mini_cart') {
              wrapDrawerSetAttribute(node);
            } else if (node.querySelector && node.querySelector('#t4s-mini_cart')) {
              const drawer = node.querySelector('#t4s-mini_cart');
              if (drawer) {
                wrapDrawerSetAttribute(drawer);
              }
            }
          }
        });
        
        // Check for drawer attribute changes (in case innerHTML was replaced but element remains)
        if (mutation.type === 'childList' && mutation.target.id === 't4s-mini_cart') {
          const drawer = mutation.target;
          if (drawer && !drawer.__ariaHiddenWrapped) {
            wrapDrawerSetAttribute(drawer);
          }
        }
      });
    });
    
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }
}

// Initialize drawer interceptor immediately
initDrawerAriaHiddenInterceptor();
// ===== END DRAWER ARIA-HIDDEN INTERCEPTOR =====

// Function to initialize the add button functionality
function initializeAddButton() {
  // Look for button in the drawer first, then globally
  const drawer = document.querySelector('#t4s-mini_cart');
  const addButton = drawer 
    ? drawer.querySelector('.add-free-product') || document.querySelector('.add-free-product')
    : document.querySelector('.add-free-product');
  
  // Only log if we're actively looking (not just checking)
  if (addButton) {
    console.log("Found add-free-product button");
  }
  
  if (addButton && !addButton.hasAttribute('data-initialized')) {
    addButton.setAttribute('data-initialized', 'true');
    addButton.addEventListener('click', async function (event) {
        event.preventDefault();
      console.log("clikccc")
      
      const variantId = this.getAttribute('data-variant-id');

      try {
        const response = await fetch('/cart/add.js', { 
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!response.ok) {
          // throw new Error(HTTP error! status: ${response.status});
        }

        const result = await response.json();
        console.log('Products added to cart:', result);
        
        // Dispatch cart update events (mark as from free product to avoid double updates)
        document.dispatchEvent(new CustomEvent('change:ajaxCart', { detail: { cart: result, fromFreeProduct: true } }));
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: result, fromFreeProduct: true } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { ...result, fromFreeProduct: true } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { fromFreeProduct: true } })); 
        document.dispatchEvent(new CustomEvent('add:cart:success', { detail: { cart: result, fromFreeProduct: true } }));
        
        try { 
          // Wait a bit for Shopify to process the cart update
          await new Promise(resolve => setTimeout(resolve, 300));
          
          // Get the latest cart data with retry logic
          let cart;
          let retries = 3;
          while (retries > 0) {
            const cartResponse = await fetch('/cart.js');
            if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
            
            cart = await cartResponse.json();
            console.log('Cart data fetched, item count:', cart.item_count);
            
            // If cart has items, break out of retry loop
            if (cart.item_count > 0) {
              break;
            }
            
            // If cart is still empty, wait and retry
            retries--;
            if (retries > 0) {
              console.log(`Cart still empty, retrying... (${retries} attempts left)`);
              await new Promise(resolve => setTimeout(resolve, 500));
            }
          }
          
          if (!cart || cart.item_count === 0) {
            console.warn('Cart appears to be empty after adding item. This may be a timing issue.');
          }
          
          // Update the count element
          const countElements = document.querySelectorAll('[data-cart-count]');
          const htmlEl = document.querySelector('html');
          const prefix = 't4s-cart-count-';
          
          // Remove existing class with the prefix
          if (htmlEl && htmlEl.classList) {
            htmlEl.classList.forEach(cls => {
              console.log("clssss", cls);
              if (cls.startsWith(prefix)) {
                htmlEl.classList.remove(cls);
              }
            });
          }
          
          countElements.forEach(element => {
            console.log("element", element);
            element.textContent = cart.item_count;
            
            // Make count visible if there are items, hide if zero
            if (cart.item_count > 0) {
              element.classList.remove('t4s-op-0');
            } else {
              element.classList.add('t4s-op-0');
            }
          });
          
          // Update the total price elements
          const priceElements = document.querySelectorAll('[data-cart-tt-price]');
          priceElements.forEach(element => {
            element.textContent = cart.total_price;
          });
          
          // Fetch and update mini cart drawer with retry
          // Only proceed if we have items in cart
          if (cart.item_count > 0) {
            let drawerUpdated = false;
            retries = 3;
            while (retries > 0 && !drawerUpdated) {
              try {
                // Add cache busting to ensure fresh data
                const drawerRes = await fetch('/?sections=mini_cart&t=' + Date.now());
                const drawerData = await drawerRes.json();
                const drawerEl = document.querySelector('#t4s-mini_cart');
                
                if (drawerEl && drawerData['mini_cart']) {
                  // Check if the fetched drawer has items by looking for the empty message
                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = drawerData['mini_cart'];
                  const emptyMessage = tempDiv.querySelector('.t4s-mini_cart__emty');
                  const hasItems = !emptyMessage || tempDiv.querySelector('[data-cart-items] .quick-cart__item, [data-cart-items] .t4s-page_cart__item');
                  
                  // Update drawer if it has items, or if this is our last retry
                  if (hasItems || retries === 1) {
                    drawerEl.innerHTML = drawerData['mini_cart'];
                    drawerUpdated = true;
                    console.log('Cart drawer updated successfully with', cart.item_count, 'items');
                    
                    // Re-initialize any buttons that might be in the drawer
                    // Wait longer to ensure HTML is fully parsed
                    setTimeout(() => {
                      initializeAddButton();
                    }, 300);
                  } else {
                    console.log('Drawer still shows empty, retrying... (attempt', 4 - retries, 'of 3)');
                    retries--;
                    if (retries > 0) {
                      await new Promise(resolve => setTimeout(resolve, 600));
                    }
                  }
                } else {
                  console.warn('Drawer element or data not found');
                  retries--;
                  if (retries > 0) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                  }
                }
              } catch (drawerError) {
                console.error('Error fetching drawer:', drawerError);
                retries--;
                if (retries > 0) {
                  await new Promise(resolve => setTimeout(resolve, 500));
                }
              }
            }
          } else {
            console.warn('Cart is empty, skipping drawer update');
          }
          
          console.log('Cart bubble updated successfully');
  
        } catch (error) {
          console.error('Error updating cart bubble:', error);
        }
        
        // Open the cart drawer after a short delay to ensure content is loaded
        setTimeout(() => {
          const cartIcon = document.querySelector('[data-drawer-options*="#t4s-mini_cart"]');
          if (cartIcon) {
            cartIcon.click();
          }
        }, 100); 
        
        // Close the offer popup after successful addition (check if offerContainer exists)
      //   const offerContainer = document.querySelector('.offer-container, .popup-container, [data-offer-popup]');
      //   if (offerContainer) {
      //     offerContainer.classList.remove('is-open');
      //   }  

      } catch (error) {
        console.error('Error adding free gift:', error);
        alert('Sorry, something went wrong.');
      }
    });
  }
}

// Initialize on page load
initializeAddButton();

// Mutation observer to watch for drawer opening
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
        // Check if nodes were added
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(function(node) {
        // Check if the added node is an element (not text node)
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if it's your specific drawer or contains drawer content
          if (node.id === 't4s-mini_cart' || 
              node.querySelector('#t4s-mini_cart') ||
              (node.classList && node.classList.contains('t4s-drawer'))) {
            console.log('T4S mini cart drawer detected, re-initializing add button');
            // Wait longer to ensure content is fully loaded
            setTimeout(initializeAddButton, 500);
          }
        }
      });
    }
    
    // Check for attribute changes on the specific drawer
    if (mutation.type === 'attributes') {
      const target = mutation.target;
      
      // Watch for changes on your specific drawer
      if (target.id === 't4s-mini_cart' || 
          (target.classList && target.classList.contains('t4s-drawer'))) {
        
        // Check if drawer became visible (t4s-dn class removed or aria-hidden changed)
        if (mutation.attributeName === 'class') {
          const hasHiddenClass = target.classList.contains('t4s-dn');
          if (!hasHiddenClass) {
            console.log('T4S drawer opened (t4s-dn class removed), re-initializing add button');
            // Wait for drawer content to be fully rendered
            setTimeout(initializeAddButton, 500);
          }
        }
        
        if (mutation.attributeName === 'aria-hidden') {
          const isHidden = target.getAttribute('aria-hidden') === 'true';
          if (!isHidden) {
            console.log('T4S drawer opened (aria-hidden changed), re-initializing add button');
            // Wait for drawer content to be fully rendered
            setTimeout(initializeAddButton, 500);
          }
        }
      }
    }
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class', 'style']
});

// Watch for your specific T4S mini cart drawer
const t4sDrawer = document.querySelector('#t4s-mini_cart');
if (t4sDrawer) {
  observer.observe(t4sDrawer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden', 'style']
  });
  console.log('T4S mini cart drawer found and being observed');
} else {
  console.log('T4S mini cart drawer not found yet, will watch for it');
}

// Helper function to close drawer safely (removes focus before hiding)
function closeDrawerSafely(drawer) {
  // Remove focus from any focused element inside the drawer before hiding
  const activeElement = document.activeElement;
  if (activeElement && drawer.contains(activeElement)) {
    // Focus body first to remove focus from the button
    if (document.body && typeof document.body.focus === 'function') {
      document.body.focus();
    } else {
      activeElement.blur();
    }
    // Use requestAnimationFrame to ensure focus is removed before aria-hidden is set
    requestAnimationFrame(() => {
      drawer.classList.add('t4s-dn');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.style.visibility = 'hidden';
      drawer.style.pointerEvents = 'none';
      if (drawer.classList.contains('t4s-drawer__right')) {
        drawer.style.transform = 'translate3d(104%, 0, 0)';
        drawer.style.webkitTransform = 'translate3d(104%, 0, 0)';
      }
    });
  } else {
    drawer.classList.add('t4s-dn');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.style.visibility = 'hidden';
    drawer.style.pointerEvents = 'none';
    if (drawer.classList.contains('t4s-drawer__right')) {
      drawer.style.transform = 'translate3d(104%, 0, 0)';
      drawer.style.webkitTransform = 'translate3d(104%, 0, 0)';
    }
  }
}

// Handle drawer close button clicks
document.addEventListener('click', function(e) {
  const closeButton = e.target.closest('[data-drawer-close]');
  if (closeButton) {
    const drawer = closeButton.closest('.t4s-drawer');
    if (drawer && drawer.id === 't4s-mini_cart') {
      // Remove focus before allowing theme to close drawer
      const activeElement = document.activeElement;
      if (activeElement && drawer.contains(activeElement)) {
        activeElement.blur();
        if (document.body) {
          document.body.focus();
        }
      }
      
      // Hide backdrop
      const backdrop = document.querySelector('.t4s-drawer-backdrop');
      if (backdrop) {
        backdrop.style.opacity = '0';
        backdrop.style.pointerEvents = 'none';
      }
      document.body.style.overflow = '';
    }
  }
});

  
// Ensure drawer opens properly when cart icon is clicked


// Global listener to update drawer when any product is added to cart
// This handles regular products (not just free products)
async function updateCartDrawer(cartData = null) {
  try {
    console.log('updateCartDrawer called');
    
    // Wait a bit for Shopify to process the cart update
    await new Promise(resolve => setTimeout(resolve, 400));
    
    // Fetch the latest cart data with retry
    let cart = cartData;
    if (!cart) {
      let retries = 3;
      while (retries > 0) {
        const cartResponse = await fetch('/cart.js?t=' + Date.now());
        if (!cartResponse.ok) {
          retries--;
          if (retries > 0) {
            await new Promise(resolve => setTimeout(resolve, 300));
            continue;
          }
          throw new Error('Failed to fetch cart data');
        }
        
        cart = await cartResponse.json();
        console.log('Cart fetched - item count:', cart.item_count);
        
        // If cart has items, break out of retry loop
        if (cart.item_count > 0) {
          break;
        }
        
        // If cart is still empty, retry
        retries--;
        if (retries > 0) {
          console.log('Cart appears empty, retrying...');
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }
    }
    
    if (!cart) {
      console.error('Failed to fetch cart after retries');
      return;
    }
    
    console.log('Updating drawer with', cart.item_count, 'items');
    
    // Fetch and update mini cart drawer with retry
    let drawerUpdated = false;
    let drawerRetries = 3;
    while (drawerRetries > 0 && !drawerUpdated) {
      try {
        const drawerRes = await fetch('/?sections=mini_cart&t=' + Date.now());
        if (!drawerRes.ok) {
          throw new Error('Failed to fetch drawer section');
        }
        
        const drawerData = await drawerRes.json();
        const drawerEl = document.querySelector('#t4s-mini_cart');
        
        if (drawerEl && drawerData['mini_cart']) {
          console.log('Drawer data fetched, checking content...');
          
          // Check if the fetched drawer has items
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = drawerData['mini_cart'];
          const emptyMessage = tempDiv.querySelector('.t4s-mini_cart__emty');
          const cartItems = tempDiv.querySelectorAll('[data-cart-items] .quick-cart__item, [data-cart-items] .t4s-page_cart__item, [data-cart-items] .t4s-mini_cart__item');
          const hasItems = !emptyMessage || cartItems.length > 0;
          
          console.log('Drawer content check - hasItems:', hasItems, 'item count:', cartItems.length, 'empty message:', !!emptyMessage);
          
          const expectedHasItems = cart.item_count > 0;
          const isContentMatching = (hasItems === expectedHasItems);
          
          // Update drawer if the content matches our expectation, or if this is our last retry
          if (isContentMatching || drawerRetries === 1) {
            console.log('Updating drawer HTML...');
            drawerEl.innerHTML = drawerData['mini_cart'];
            drawerUpdated = true;
            console.log('✅ Cart drawer updated successfully with', cart.item_count, 'items');
            
            if (cart.item_count > 0) {
              // Show offer slider if cart has items
              const offerSlider = drawerEl.querySelector('.offer-slider-wrapper');
              if (offerSlider) {
                offerSlider.style.display = '';
                console.log('Offer slider shown');
              }

              // Show cart product slider if cart has items
              const cartProductSlider = drawerEl.querySelector('.cart-product-slider-wrapper');
              if (cartProductSlider) {
                cartProductSlider.style.display = '';
                console.log('Cart product slider shown');
              }
            } else {
              // Hide sliders when cart is empty
              const offerSlider = drawerEl.querySelector('.offer-slider-wrapper');
              if (offerSlider) {
                offerSlider.style.display = 'none';
                console.log('Offer slider hidden (cart empty)');
              }

              const cartProductSlider = drawerEl.querySelector('.cart-product-slider-wrapper');
              if (cartProductSlider) {
                cartProductSlider.style.display = 'none';
                console.log('Cart product slider hidden (cart empty)');
              }
            }
            
            // Re-initialize buttons after drawer update
            setTimeout(() => {
              initializeAddButton();
              console.log('Add button re-initialized');
            }, 300);
          } else {
            console.log('⚠️ Drawer content does not match expectation, retrying... (attempt', 4 - drawerRetries, 'of 3)');
            drawerRetries--;
            if (drawerRetries > 0) {
              await new Promise(resolve => setTimeout(resolve, 600));
            }
          }
        } else {
          console.warn('❌ Drawer element or data not found - drawerEl:', !!drawerEl, 'drawerData:', !!drawerData['mini_cart']);
          drawerRetries--;
          if (drawerRetries > 0) {
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }
      } catch (drawerError) {
        console.error('Error fetching drawer:', drawerError);
        drawerRetries--;
        if (drawerRetries > 0) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }
    }
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}



const cartUpdateEvents = [
  'change:ajaxCart',
  'cart:update', 
  'cart:updated',
  'add:cart:success',
  'cart:refresh'
];

cartUpdateEvents.forEach(eventName => {
  document.addEventListener(eventName, function(event) {
    console.log('Cart update event detected:', eventName);
    // Only update if this isn't from our free product handler
    // (to avoid double updates - free product handler updates drawer itself)
    const isFromFreeProduct = event.detail && (
      event.detail.fromFreeProduct === true || 
      (typeof event.detail === 'object' && event.detail.fromFreeProduct === true)
    );
    
    if (!isFromFreeProduct) {
      const cartData = event.detail && (event.detail.token || event.detail.item_count !== undefined) 
        ? event.detail 
        : (event.detail && event.detail.cart);
      updateCartDrawer(cartData);
    } else {
      console.log('Skipping drawer update (handled by free product handler)');
    }
    
  });
});
});



document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
      const css = `
          .flickityt4s-viewport .t4s-product.t4s-pr-grid.t4s-pr-style6 {
              height: inherit;
          }
          .flickityt4s-viewport .t4s-product-wrapper {
              height: inherit;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
          }
          .flickityt4s-viewport .t4s-product .t4s-product-info {
              height: inherit;
          }
          .flickityt4s-viewport .t4s-product .t4s-product-inner {
              overflow: unset;
          }
          .flickityt4s-viewport .t4s-pr-style6 .t4s-product-info__inner {
              display: flex;
              flex-direction: column;
              height: inherit;
              text-align: center;
          }
          .flickityt4s-viewport .t4s-product .t4s-product-title {
              display: flex;
              flex-direction: column;
              height: 100%;
          }
      `;

      // Create a <style> element
      const style = document.createElement("style");
      style.type = "text/css";
      style.appendChild(document.createTextNode(css));
console.log('activate');
      // Append the <style> element to the <head> or <body>
      document.head.appendChild(style);
  }, 2000); // Timeout of 1 second
});



jQuery_T4NT(document).ready(function($) {

    /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
    $( document ).on( "variant:changed", function( evt ) {
      // console.log( evt.currentVariant );
      // $('[data-variant-toggle]').hide(0);
      // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
    });

});



document.addEventListener("DOMContentLoaded", function () {
// setTimeout(() => {
//   const productMetas = document.querySelectorAll(".t4s-product-wrapper");
//   const meta = document.querySelector(".product__meta");
//   productMetas.forEach((productMeta) => {
//     const reviewWrapper = productMeta.querySelector("#epr-product-collection-review");
//     if (!reviewWrapper) return;

//     const productId = reviewWrapper.getAttribute("data-product-id");
//     if (!productId) return;

//     const reviewBlock = reviewWrapper.querySelector("span");
//     if (!reviewBlock) return; 

//     const meta = productMeta.closest(".product-item__inner")?.querySelector(".product-item__meta");
//     if (!meta) return;

//     const rating = meta.dataset.rating;
//     const reviews = meta.dataset.review;

//     if (rating) {
//       reviewBlock.innerHTML = `
//       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffc800" class="bi bi-star-fill" viewBox="0 0 16 16">
//         <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
//       </svg>
//       ${rating}${reviews ? ` | ${reviews}` : ""}
//     `;
//       // ✅ Show wrapper only after content is injected
//       reviewWrapper.style.display = "block";
//     }
//   });
// }, 4000);
setTimeout(() => {
  // Product page
  const meta = document.querySelector(".t4s-product__info-container");

  const reviewWrapper = document.querySelector("#epr-product-title-review");
  if (!meta || !reviewWrapper) return;

  const reviewBlock = reviewWrapper.querySelector("span");
  if (!reviewBlock) return;

  const rating = meta.dataset.rating;
  const reviews = meta.dataset.review;

  if (rating) {
    reviewBlock.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffc800" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
    </svg>
    ${rating}${reviews ? ` | ${reviews} Ratings` : ""}
  `;
}
reviewWrapper.style.display = "block";
}, 1000)
setTimeout(() => {
  const meta = document.querySelector(".t4s-product__info-container");

  const reviewWrap = document.querySelector(".mag-review-count-wrapper");
  console.log(".mag-review-count-wrapper", reviewWrap)


  if (meta && reviewWrap) {
    const rating = meta.dataset.rating;
    const reviews = meta.dataset.review;

    if (rating) {
      // Intersection Observer for when reviewWrap comes into view
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Create new div when element is visible
            const newDiv = document.createElement("div");
            newDiv.className = "product-page-rating";
            newDiv.innerHTML = `
          
            ${reviews ? ` ${reviews} Ratings` : ""}
          `;
            reviewWrap.insertAdjacentElement("afterend", newDiv);
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.2 // trigger when 20% visible
      });

      observer.observe(reviewWrap);
    }
  }
}, 5000)
}); 


// Free Shipping progress bar
if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', class FreeShippingProgress extends HTMLElement {
    constructor() {
      super();
      const thresholdValue = parseFloat(this.dataset.freeThreshold) || parseFloat(this.getAttribute('data-free-threshold')) || 0;
      this.threshold = thresholdValue > 1000 ? thresholdValue / 100 : thresholdValue;
      if (this.threshold <= 0) {
        this.threshold = 999; // Default fallback
      }
      
      const initialTotal = parseFloat(this.dataset.totalAmount) || parseFloat(this.getAttribute('data-total-amount')) || 0;
      this.cartTotal = initialTotal > 1000 ? initialTotal / 100 : initialTotal;
      
      this.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      console.log('Free shipping progress initialized:', {
        threshold: this.threshold,
        initialCartTotal: this.cartTotal,
        currency: this.currency
      });
    }

    connectedCallback() {
      setTimeout(() => {
        this.init();
        this.triggerFirstProductInit();
        this.fetchCartTotal();
        this.watchDrawerUpdates();
      }, 100);
    }

    watchDrawerUpdates() {
      const drawer = document.querySelector('#t4s-mini_cart');
      if (!drawer) {
        console.warn('Drawer not found for free shipping progress watcher');
        return;
      }
      const visibilityObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            const isHidden = drawer.getAttribute('aria-hidden') === 'true';
            if (!isHidden) {
              console.log('Drawer opened, updating free shipping progress');
              setTimeout(() => {
                const thresholdValue = parseFloat(this.dataset.freeThreshold) || parseFloat(this.getAttribute('data-free-threshold')) || 0;
                if (thresholdValue > 0) {
                  this.threshold = thresholdValue > 1000 ? thresholdValue / 100 : thresholdValue;
                }
                
                const totalAmount = parseFloat(this.dataset.totalAmount) || parseFloat(this.getAttribute('data-total-amount')) || 0;
                if (totalAmount > 0) {
                  this.cartTotal = totalAmount > 1000 ? totalAmount / 100 : totalAmount;
                }
                
                this.fetchCartTotal();
              }, 300);
            }
          }
        });
      });

      visibilityObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
      
      const cartUpdateEvents = ['cart:updated', 'cart:update', 'change:ajaxCart', 'cart:refresh', 'add:cart:success'];
      cartUpdateEvents.forEach(eventName => {
        document.addEventListener(eventName, () => {
          setTimeout(() => {
            this.fetchCartTotal();
          }, 100);
        });
      });
    }

    init = () => {
      this.initProgressBar();
      this.updateCartTotal();
      this.updateQuickCartTotal();
    }

    updateCartTotal() {
      const cartUpdateEvents = [
        'cart:updated', 
        'cart:update', 
        'cart-drawer:updated', 
        'cart-line-items:updated', 
        'cart-drawer:open',
        'cart-added',
        'change:ajaxCart',
        'cart:refresh'
      ];

      cartUpdateEvents.forEach(eventName => {
        document.addEventListener(eventName, (e) => {
          let cartTotal = 0;
          let itemCount = 0;

          if (e.detail && e.detail.cart) {
            cartTotal = e.detail.cart.total_price / 100;
            itemCount = e.detail.cart.item_count;
          } else if (e.detail && e.detail.total_price) {
            cartTotal = e.detail.total_price / 100;
            itemCount = e.detail.item_count || 1;
          } else {
            this.fetchCartTotal();
            return;
          }

          this.cartTotal = cartTotal;
          this.updateCartBubble(itemCount);
          this.renderProgress();

          if (itemCount > 0) {
            this.style.display = 'block';
          } else {
            this.style.display = 'none';
          }
        });
      });
    }

    updateQuickCartTotal = () => {
      const cartTotalSelectors = [
        '.quick-cart__footer-subtotal [data-total-price]',
        '[data-cart-total-price]',
        '.t4s-mini_cart__total [data-total-price]',
        '.t4s-cart__total-price',
        '[data-cart-total]'
      ];

      cartTotalSelectors.forEach(selector => {
        const cartTotalElement = document.querySelector(selector);
        if (cartTotalElement) {
          if (!this.cartUpdateChangeMutation) {
            this.cartUpdateChangeMutation = new MutationObserver(() => {
              this.fetchCartTotal();
            });
          }
          this.cartUpdateChangeMutation.observe(cartTotalElement, {  
            childList: true, 
            subtree: true,
            characterData: true
          });
        }
      });

      const cartItemsContainer = document.querySelector('[data-cart-items]');
      if (cartItemsContainer) {
        if (!this.cartItemsObserver) {
          this.cartItemsObserver = new MutationObserver(() => {
            setTimeout(() => {
              this.fetchCartTotal();
            }, 100);
          });
        }
        this.cartItemsObserver.observe(cartItemsContainer, {
          childList: true,
          subtree: true
        });
      }
    }

    triggerFirstProductInit() {
      const addToCartButtons = document.querySelectorAll('.grid-product__meta [name="add"], .add-to-cart');
      const addToCartForms = document.querySelectorAll('.grid-product__meta form[action="/cart/add"]');

      [...addToCartButtons, ...addToCartForms].forEach(element => {
        element.addEventListener('click', () => {
          this.style.display = 'block';
          this.fetchCartTotal();

          const cartAddedEvent = new CustomEvent('cart-added', { detail: { triggerUpdate: true } });
          document.dispatchEvent(cartAddedEvent);
        });
      });
    }

    fetchCartTotal() {
      fetch('/cart.js?t=' + Date.now(), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(res => {
        if (!res.ok) {
          throw new Error('Failed to fetch cart');
        }
        return res.json();
      })
      .then(cart => {
        const newCartTotal = cart.total_price / 100;
        if (this.cartTotal !== newCartTotal) {
          this.cartTotal = newCartTotal;
          console.log('Cart total updated:', this.cartTotal, 'Threshold:', this.threshold);
          this.updateCartBubble(cart.item_count);
          this.renderProgress();
        }

        if (cart.item_count > 0) {
          this.style.display = 'block';
        } else {
          this.style.display = 'none';
        }
      })
      .catch(err => {
        console.error('Error fetching cart total:', err);
        // Still render with current cart total
        this.renderProgress();
      });
    }

    updateCartBubble(itemCount) {
      const bubble = document.querySelector('.cart-link__bubble');
      if (!bubble) return;

      if (itemCount > 0) {
        bubble.textContent = itemCount;
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.textContent = '0';
        bubble.classList.remove('cart-link__bubble--visible');
      }
    }

    initProgressBar() {
      this.renderProgress();
    }


    formatPriceAmount(amount, currency) {
      const noDecimalCurrencies = ["JPY", "KRW", "VND", "IDR", "INR"];  
      const hasNoDecimals = noDecimalCurrencies.includes(currency);

      const price = (amount / 100).toLocaleString(undefined, {
        minimumFractionDigits: hasNoDecimals ? 0 : 2,
        maximumFractionDigits: hasNoDecimals ? 0 : 2,
      });

      if (window["priceFormatTemplate"]) {
        return window["priceFormatTemplate"].replace(/[\d,.]+/, price);
      }

      return `${Shopify.currency.symbol}${price}`;
    }


    renderProgress() {
      const progressBar = this.querySelector('.free-shipping-progress');
      const messageWrapper = this.querySelector('.free-shipping-message');

      const textBefore = this.dataset.textBefore || this.getAttribute('data-text-before') || 'YOU ARE';
      const textAfter = this.dataset.textAfter || this.getAttribute('data-text-after') || 'AWAY FROM FREE SHIPPING!';
      const unlockedText = this.dataset.unlockedText || this.getAttribute('data-unlocked-text') || '🎉 Congratulations! Free shipping unlocked!';

      const freeThresholdCents = Math.round(this.threshold * 100);
      const cartTotalCents = Math.round(this.cartTotal * 100);
      
      let progress = 0;
      if (freeThresholdCents > 0) {
        progress = Math.min((cartTotalCents * 100) / freeThresholdCents, 100);
      }

      console.log('Rendering progress:', {
        cartTotal: this.cartTotal,
        cartTotalCents: cartTotalCents,
        threshold: this.threshold,
        freeThresholdCents: freeThresholdCents,
        progress: progress
      });

      if (progressBar) {
        progressBar.style.setProperty('--free-shipping-progress', `${progress}%`);
        
        const progressDot = this.querySelector('.free-shipping-progress-dot');
        if (progressDot) {
          const dotPosition = Math.min(progress, 100);
          progressDot.style.left = `${dotPosition}%`;
        }
      }

      if (messageWrapper) {
        if (cartTotalCents >= freeThresholdCents) {
          messageWrapper.innerHTML = unlockedText;
          this.classList.add('free-has-unlocked');
        } else {
          const amountToQualify = freeThresholdCents - cartTotalCents;
          let formatted = this.formatPriceAmount(amountToQualify, this.currency);
          if (typeof formatted === 'string') {
            formatted = formatted.replace(/^undefined/, '').trim();
            // Remove currency symbol if already present to avoid duplication
            formatted = formatted.replace(/^[^\d]/, '').trim();
          }
          formatted = '$' + formatted;
          const message = `${textBefore} <span>${formatted}</span> ${textAfter}`;
          messageWrapper.innerHTML = message;
          this.classList.remove('free-has-unlocked');
        }
      }

      if (this.hasAttribute('data-confetti')) {
        document.dispatchEvent(new CustomEvent('freeShippingUnlocked', {
          detail: { status: progress >= 100 }
        }));
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const picker = document.querySelector('[data-bundle-picker]');
  if (!picker) return;

  const options = picker.querySelectorAll('.bundle-option');
  const qtyInput = document.querySelector('input[name="quantity"]');

  const addToCartBtn =
    document.querySelector('button[name="add"]') ||
    document.querySelector('[data-add-to-cart]');

  if (!options.length || !qtyInput || !addToCartBtn) return;

  let selectedBundleQty = 1;

  options.forEach(option => {
    option.addEventListener('click', (e) => {
      e.stopPropagation();

      options.forEach(o => o.classList.remove('active'));
      option.classList.add('active');
      selectedBundleQty = parseInt(option.dataset.bundleQty, 10) || 1;
    });
  });

  // options[0]?.click();

  addToCartBtn.addEventListener('click', function () {
    const userQty = parseInt(qtyInput.value, 10) || 1;
    const finalQty = userQty * selectedBundleQty;
    const originalQty = qtyInput.value;

    qtyInput.value = finalQty;

    requestAnimationFrame(() => {
      qtyInput.value = originalQty;
    });
  });

});
// cart open js

  document.addEventListener('DOMContentLoaded', function() {
   
    document.addEventListener('cart:item-added', function(event) {
      var cartStatus = document.getElementById('cart-status');
      if (cartStatus) {
        cartStatus.textContent = "Item added to cart successfully.";
      }
    });
  });
